/** @jsx jsx */
import { jsx } from '@emotion/react';

import RelatedSkillsComponent from 'bundles/browse-common/components/RelatedSkillsComponent';
import { usePageConfigComponentMetadata } from 'bundles/page-config-common/contexts/PageConfigComponentMetadataContext';
import useRelatedSkills from 'bundles/search-common/hooks/useRelatedSkills';
import { useMediumIntentContext } from 'bundles/search-common/providers/MediumIntentProvider';

import _t from 'i18n!nls/search-common';

const CoreSkillsForDomainRenderer = () => {
  const pageConfigComponentMetadataContext = usePageConfigComponentMetadata();

  const { mediumIntentData, loading: mediumIntentLoading } = useMediumIntentContext();
  const matchedEntity = mediumIntentData?.matchedEntity;
  const entityType = mediumIntentData?.entityType;
  const { skills = [], loading: skillsLoading } = useRelatedSkills(
    matchedEntity ? [matchedEntity.trim().replace(' ', '-')] : []
  );

  if (!pageConfigComponentMetadataContext || entityType !== 'domain') {
    return null;
  }

  const { index } = pageConfigComponentMetadataContext;

  if (mediumIntentLoading || skillsLoading) {
    return null;
  }

  if (skills.length === 0) {
    return null;
  }

  const title = _t('Core skills in #{matchedEntity}', { matchedEntity });
  return <RelatedSkillsComponent title={title} skills={skills} showPageTitleHeadingSize={index === 0} />;
};

export default CoreSkillsForDomainRenderer;
